<template>
  <div class="flex-center">
    <v-btn color="primary" @click="onAdd"> <v-icon left>add</v-icon>{{ addButtonText }} </v-btn>
    <v-btn
      v-show="selected.length"
      color="error"
      :class="{ 'ml-2': $vuetify.breakpoint.mdAndUp }"
      depressed
      @click="onRemove"
    >
      <v-icon left>delete</v-icon>Xóa khỏi lớp
    </v-btn>
    <student-add-dialog :state="addState" :lastSelectedStudents="students" />
  </div>
</template>

<script>
import { Class } from '@/plugins/api'

import { mapActions, mapGetters } from 'vuex'
import StudentAddDialog from '@/modules/class/student/StudentAddDialog'
export default {
  components: {
    StudentAddDialog
  },
  props: {
    disabled: Boolean,
    selected: { type: Array, default: () => [] }
  },
  data() {
    return {
      addState: false,
      sending: null
    }
  },
  computed: {
    ...mapGetters('classDetail', ['students', 'classData']),
    ...mapGetters('app', ['policies']),
    sendingName() {
      const { name } = this.students.find(student => student.phone === this.sending)
      return name
    },
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm học sinh'
      }
    }
  },
  methods: {
    ...mapActions('classDetail', ['updateClass', 'removeClassDataRelatedToStudent']),
    ...mapActions('noti', ['sendEmails', 'sendSMS']),
    onAdd() {
      this.addState = !this.addState
    },
    onRemove() {
      this.$dialog.confirm({
        title: 'Xóa Khỏi Danh Sách Lớp',
        text: 'Bạn có muốn xóa học sinh này ra khỏi lớp, các dữ liệu của lớp liên quan đến học sinh này sẽ bị xóa và không thể khôi phục?',
        okText: 'Đồng Ý',
        cancelText: 'Không',
        done: async () => {
          await this.updateClass({
            ...this.classData,
            students: this.students
              .map(s => s.id)
              .filter(stid => {
                return !(this.selected.map(s => s.id).indexOf(stid) >= 0)
              })
          })
          await Class.removeStudentData(this.classData.id, {
            params: {
              students: this.selected.map(s => s.id)
            }
          })
        }
      })
    }
  }
}
</script>
